<template>
    <div>
        <div role="alert" class="alert alert-info alert-dismissible fade show">
            <h4>
                <span class="  d-flex justify-content-start align-items-center ">
                    <i class="fs-5 material-icons mr-2">info</i>
                    <span class="">Have you created the vip ticket yet?</span>
                </span>
            </h4>
            <div>
                <p>Create the ticket first, then come back here</p>
                <div class="d-flex justify-content-center align-items-center ">
                    <button type="button" class="btn btn-outline-info" data-dismiss="alert" aria-label="Close">
                        yes
                    </button>
                    <a class="btn btn-info" target="_blank" :href="create_vip_ticket_uri">No, create now</a>
                </div>
            </div>

            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <i aria-hidden="true" class="material-icons">close</i>
            </button>
        </div>

        <div v-if="set_dev"
             class="row">
            <div class="col">
                <div :class="{
                'yup':canImport,
                'nope':!canImport,

                }">canImport
                </div>
                <div :class="{
                'yup':ticketIsSelected,
                'nope':!ticketIsSelected,

                }">ticketIsSelected
                </div>
                <div :class="{
                'yup':ticketIsSelected,
                'nope':!ticketIsSelected,

                }">ticketIsSelected
                </div>
                <div :class="{
                'yup':uploaderIsInitial,
                'nope':!uploaderIsInitial

                }">uploaderIsInitial
                </div>
                <div :class="{
                'yup':canAllocate,
                'nope':!canAllocate

                }">canAllocate
                </div>
                <div :class="{
                'yup':uploader_status,
                'nope':!uploader_status

                }">uploader_status:{{uploader_status}}
                </div>
                <div :class="{
                'yup':hasImportedErrors,
                'nope':!hasImportedErrors

                }">imported_checklist.has_errors
                </div>
            </div>
        </div>
        <!--Navigation-->
        <div class="navbar navbar-light">
            <div class="row w-100">
                <!--ticket type selector-->
                <div class="order-2 order-md-1 col-12 col-md-4 d-flex">
                    <BaseSwitch
                            :tabindex="0"
                            class="px-2 w-100 align-self-center"
                            :checked="isSeasonTicket()"
                            @input_value="switchToSeasonTicket"
                            field="status"
                            identifier="status"
                            :label="null"
                            switch_off="Single Tickets"
                            switch_on="Season Tickets"
                            title="Select VIP ticket type"
                            :tooltip="true"
                    ></BaseSwitch>
                </div>
                <!--material selector-->
                <div class="order-3 order-md-2 col-12 col-md-4">
                    <section data-ref="SeasonTicketSelector"
                             :class="isSeasonTicket() ? '':'d-none'">
                        <div id="ticket_material_select--wrapper">
                            <material-select ref="ticket_chooser_select"
                                             :id="season_ticket_chooser.id"
                                             @material_select_result="ticketMaterialSelect"
                            ></material-select>
                        </div>
                    </section>
                    <section data-ref="SingleTicketSelector"
                             :class="isSeasonTicket() ? 'd-none' :''">
                        <div id="material_select--wrapper">
                            <material-select ref="event_chooser_select"
                                             :id="event_chooser.id"
                                             @material_select_result="eventMaterialSelect"
                            ></material-select>
                        </div>
                    </section>
                </div>
                <!--Importer-->
                <div class="order-4 order-md-3 col-6 col-md-3">
                    <div class="h-100 d-flex justify-content-between align-content-center">
                        <BaseButton
                                :cls="[
                                        {
                                        'disabled':!canImport|uploaderIsSaving
                                        },
                                        'mx-auto align-self-center'
                                    ]"
                                @click="showImportDialog">Import CSV
                        </BaseButton>
                    </div>
                </div>
                <!--bookmark-->
                <div class="order-1 order-md-3 col-1">
                    <div class="h-100 d-flex justify-content-between align-content-center">
                        <div class="align-self-center">
                            <add_to_bookmark
                                    :store="bookmark_store"
                                    :route="bookmark_route"
                            ></add_to_bookmark>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- import dialog-->
        <transition name="fade">
            <template v-if="import_file.show_import_dialog">
                <form enctype="multipart/form-data"
                      novalidate
                      v-if="uploaderIsInitial() || uploaderIsSaving()">
                    <div class="card">
                        <div class="card-body">
                            <template v-if="isSingleTicket() ">
                                <material-select
                                        class="m0"
                                        :id="single_ticket_chooser.id"
                                        ref="single_ticket_chooser_select"
                                        data-ref="single_ticket_chooser_select"
                                        @material_select_result="singleMaterialTicketSelect"
                                />

                            </template>
                            <div>
                                <BaseButton
                                        type="div"
                                        :small="true"
                                        btn_type="btn-danger"
                                        cls="mx-auto align-self-center"
                                        @click="createTemplateCSV">
                                    <div class="d-flex justify-content-between align-content-center">
                                        <div class="align-self-center">Download Template</div>
                                        <i class="cursor-pointer material-icons"
                                        >file_download</i>
                                    </div>
                                </BaseButton>
                            </div>
                            <div class="dropbox"
                                 v-if="current_ticket_id !== null"
                            >
                                <input type="file"
                                       :name="uploadFieldName"
                                       :disabled="uploaderIsSaving()"
                                       @change="uploadFileChange"
                                       :accept="import_file.csv_type"
                                       class="input-file">
                                <p v-if="uploaderIsInitial()">
                                    Drag your csv file here to begin<br> or click to browse
                                </p>
                                <div class="p-3"
                                     v-if="uploaderIsSaving()">
                                    <BaseLoadingAnimation
                                            text="please wait while importing csv..."></BaseLoadingAnimation>
                                    <bold-words class="text-center my-3 text-uppercase"
                                                element_type="div"
                                                :word="{
                                                text:'do not refresh this page'}"
                                    ></bold-words>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </template>
        </transition>

        <!--Importer Response Card-->
        <template v-if="canImport">
            <div v-if="uploader_status"
                 data-ref="import__dialog"
                 role="alert"
                 class="alert fade show"
                 :class="{
                                    'alert-danger':imported_checklist.has_errors,
                                    'alert-success alert-dismissible':!imported_checklist.has_errors,
                                }"
            >

                <div v-if="imported_checklist.no_spaces === true">
                    <div class="d-flex justify-content-between align-content-center">
                        <h4>
                            <span class="d-flex justify-content-start align-items-center ">
                            <i class="fs-5 material-icons mr-2">warning</i>
                            <span>No more spaces available.</span></span>
                        </h4>
                        <div class="d-flex justify-content-end align-content-center">
                            <div class="pl-1">
                                <BaseButton
                                        type="div"
                                        :small="true"
                                        btn_type="btn-danger"
                                        cls="mx-auto align-self-center"
                                        @click="exportToCSV">
                                    <div class="d-flex justify-content-between align-content-center">
                                        <div class="align-self-center">Download now</div>
                                        <i class="cursor-pointer material-icons"
                                        >file_download</i>
                                    </div>
                                </BaseButton>
                            </div>
                            <div class="pl-1">
                                <BaseButton
                                        type="div"
                                        :small="true"
                                        btn_type="btn-danger"
                                        cls="mx-auto align-self-center"
                                        @click="resetImporter">
                                    <div class="d-flex justify-content-between align-content-center">
                                        <div class="align-self-center">Close</div>
                                        <i class="cursor-pointer material-icons"
                                        >close</i>
                                    </div>
                                </BaseButton>
                            </div>
                        </div>
                    </div>

                    <p>{{getTotalFailedImports}} out of {{getTotalSuccessfulImports}}
                        {{getTotalSuccessfulImports > 1?'records were':'record was'}} not imported. You must download
                        the remaining records.</p>
                </div>
                <div v-else-if="imported_checklist.has_errors">
                    <div>
                        <div class="d-flex justify-content-between align-content-center">
                            <h4>
                            <span class="  d-flex justify-content-start align-items-center ">
                            <i class="fs-5 material-icons mr-2">warning</i>
                            <span>{{imported_checklist.invalid.count}} out of {{getTotalSuccessfulImports}} {{getTotalSuccessfulImports > 1?'records were':'record was'}} not imported</span></span>
                            </h4>
                            <div class="d-flex justify-content-end align-content-center">
                                <div class="pl-1">
                                    <BaseButton
                                            type="div"
                                            :small="true"
                                            btn_type="btn-secondary"
                                            cls="mx-auto align-self-center"
                                            @click="exportToCSV">
                                        <div class="d-flex justify-content-between align-content-center">
                                            <div class="align-self-center">Export</div>
                                            <i class="cursor-pointer material-icons"
                                            >file_download</i>
                                        </div>
                                    </BaseButton>
                                </div>
                                <div class="pl-1">
                                    <BaseButton
                                            type="div"
                                            :small="true"
                                            btn_type="btn-danger"
                                            cls="mx-auto align-self-center"
                                            @click="resetImporter">
                                        <div class="d-flex justify-content-between align-content-center">
                                            <div class="align-self-center">Close</div>
                                            <i class="cursor-pointer material-icons"
                                            >close</i>
                                        </div>
                                    </BaseButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="small">Correct each highlighted field and hit Enter on the keyboard to check. Once
                        there are no highlighted fields, click the Update button to send a</p>
                    <TableEditor
                            :headers="imported_checklist.headers"
                            :records="imported_checklist.invalid.data"
                            :validate="{
                                                use:true,
                                                url:import_ticket_validate_field_url
                                            }"
                            button_title="Update"
                            :submit_url="uploaderUrl"
                            :submit_additional_params="{
                                                selected_ticket:getSelectedTicket
                                            }"
                            @complete="invalidRecordsCorrected"

                    ></TableEditor>
                </div>
                <div v-else>
                    <h4>
                                    <span class="  d-flex justify-content-start align-items-center ">
                                        <i class="fs-5 material-icons mr-2">check</i>
                                        <span>{{total_imported}} {{total_imported > 0 ? 'Imports have' : 'Import has'}} been scheduled for creation</span></span>
                    </h4>
                    <p class="small">Records are imported in the background, which may take some time to create.
                        This
                        is
                        dependant on multiple reasons such as server load.</p>
                    <p class="small">If you wish to check the status of the imports please come back after some
                        time</p>
                    <BaseButton
                            @click="resetImporter">Thank you.
                    </BaseButton>
                </div>
            </div>
        </template>

        <!--Show single ticket stats-->
        <template v-if="isSingleTicket()">
            <div v-if="table_list_active && editing_single_sale" class="table-responsive">
                <table class="table table-responsive-sm table-bordered table-striped">
                    <thead>
                    <tr>
                        <td>Ticket</td>
                        <td>Allocated</td>
                        <td>Spaces Available</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="loading_spaces_available">
                        <td colspan="3">Loading</td>
                    </tr>
                    <tr v-else v-for="ticket in selected_tickets_for_event">
                        <td>{{ticket.lang.en_GB.title}}</td>
                        <td>{{ticket.allocated}}</td>
                        <td>{{ticket.spaces}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <!--display (season tickets) based on events-->
        <section class="">
            <!--List of reservation-->
            <div v-if="table_list_active"
                 data-ref="season--table_list_active"
            >
                <div>
                    <div class="d-flex flex-column"
                         :class="{
                        'flex-md-row justify-content-between align-content-center':isSeasonTicket(),
                        }"
                    >
                        <!-- season ticket Allocations-->
                        <template v-if="isSeasonTicket() && table_list_active"
                                  data-ref="season--table_list_active--allocations">
                            <template v-if="loading_spaces_available">
                                <div>Loading</div>
                            </template>
                            <template v-else
                                      v-for="ticket in selected_tickets_for_event">
                                <div class="d-flex flex-column flex-sm-row mt-2 mt-sm-0 justify-content-between align-content-center">
                                    <div class="d-flex">
                                        <div class="d-flex px-2">
                                            <div class="align-self-center pr-1">Allocated:</div>
                                            <div class="align-self-center badge badge-pill badge-info">
                                                {{ticket.allocated}}
                                            </div>
                                        </div>
                                        <div class="d-flex pr-2">
                                            <div class="align-self-center pr-1">Spaces Available:</div>
                                            <div class="align-self-center badge badge-pill"
                                                 :class="{
                                                    'badge-danger':ticket.spaces <= 0,
                                                    'badge-info':ticket.spaces > 0,
                                                }"
                                            >
                                                {{ticket.spaces}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="d-flex pr-2">
                                            <div class="align-self-center ">
                                                <BaseButton
                                                        :small="true"
                                                        type="a"
                                                        :href="getTicketRoute(ticket)"
                                                        target="_blank"
                                                >
                                                    <div class="d-flex justify-content-between align-content-center">
                                                        <div class="align-self-center">View Ticket</div>

                                                        <i class="material-icons">pageview</i>
                                                    </div>
                                                </BaseButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- single ticket allocations -->
                        <template v-else>
                            <div class="card ">
                                <div class="card-body" v-if="table_list_active">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-hover thead-light">
                                            <thead>
                                            <tr>
                                                <th class="cursor-pointer w-50"
                                                    @click="view_all_allocations=!view_all_allocations"
                                                >
                                                    <div>
                                                        <div class="d-inline-block">Ticket{{selected_tickets_for_event
                                                            !== null &&
                                                            selected_tickets_for_event.length > 1 ? 's': ''}}
                                                        </div>
                                                        <div class="d-inline-block position-relative"
                                                        >
                                                            <i class="material-icons position-absolute"
                                                               style="bottom: -7px;right: -20px;position: absolute;">
                                                                {{view_all_allocations?'expand_less':'expand_more'}}</i>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th class="cursor-pointer">Allocated</th>
                                                <th class="cursor-pointer">Spaces Available</th>
                                                <th class="cursor-pointer">Edit ticket</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-if="loading_spaces_available">
                                                <td colspan="3">Loading</td>
                                            </tr>
                                            <template v-else>
                                                <template v-for="ticket in selected_tickets_for_event">
                                                    <tr
                                                            v-if="show_allocations(ticket)"
                                                            @click="showOneTicketOnly(ticket)"
                                                            class="cursor-pointer"
                                                            :class="{
                                            'table-info':view_single_ticket !== null && ticket.id === view_single_ticket.id
                                        }"
                                                    >
                                                        <td>{{ticket.lang.en_GB.title}}</td>
                                                        <td>{{ticket.allocated}}</td>
                                                        <td>{{ticket.spaces}}</td>
                                                        <td>
                                                            <BaseButton
                                                                    :small="true"
                                                                    type="a"
                                                                    :href="getTicketRoute(ticket)"
                                                                    target="_blank"
                                                            >
                                                                <div class="d-flex justify-content-between align-content-center">
                                                                    <div class="align-self-center">View Ticket</div>

                                                                    <i class="material-icons">pageview</i>
                                                                </div>
                                                            </BaseButton>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            </tbody>
                                            <tfoot>
                                            <tr v-if="view_single_ticket === null">
                                                <td>All Tickets</td>
                                                <td>{{getTotalAllocation}}</td>
                                                <td>{{getTotalSpaces}}</td>
                                            </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class=" d-flex"
                             :class="{
                                    'flex-column flex-sm-row  justify-content-between align-content-center':isSeasonTicket(),
                                    'justify-content-end align-content-center':isSingleTicket(),
                                }"
                        >
                            <div class="pr-4 d-flex w-100 w-sm-75 w-md-initial">
                                <input class="align-self-center"
                                       type="text"
                                       v-model="searchString"
                                       placeholder="Customer"/>
                            </div>
                            <div class="d-flex justify-content-end align-content-center">
                                <BaseIconButton
                                        :float="true"
                                        theme="btn-secondary"
                                        @click_event="loadRows()"
                                        :icon="{
                                            content:'refresh'
                                        }"
                                        tag_name="div"
                                ></BaseIconButton>
                                <BaseIconButton
                                        :float="true"
                                        class="btn-primary"
                                        @click_event="prevPage"
                                        :icon="{
                                            content:'skip_previous'
                                        }"
                                        tag_name="div"
                                ></BaseIconButton>
                                <div class="d-flex justify-content-between align-content-center">
                                    <div class="align-self-center badge badge-pill badge-info">
                                        {{currentPage}}
                                    </div>
                                    <span class="small align-self-center mx-1 text-muted">of</span>
                                    <div class="align-self-center badge badge-pill badge-info">
                                        {{number_of_pages}}
                                    </div>
                                </div>
                                <BaseIconButton
                                        :float="true"
                                        class="btn-primary"
                                        :theme="!can_use_next ? 'disabled' : 'active'"
                                        @click_event="nextPage"
                                        :icon="{
                                            content:'skip_next'
                                        }"
                                        tag_name="div"
                                ></BaseIconButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="table-responsive">
                        <table class="table table-sm table-hover thead-dark">
                            <thead>
                            <tr>
                                <th class="cursor-cell" v-on:click="sort('created_at')">Created</th>
                                <th class="cursor-cell text-nowrap" v-on:click="sort('first_name')">First name</th>
                                <th class="cursor-cell text-nowrap" v-on:click="sort('last_name')">Last name</th>
                                <th class="cursor-cell" v-on:click="sort('email')">Email</th>
                                <th class="cursor-cell" v-on:click="sort('telephone')">Telephone</th>
                                <th class="cursor-pointer">Plates</th>
                                <th v-if="isSingleTicket()" v-on:click="sort('ticket')" class="cursor-pointer">Ticket
                                </th>
                                <th class="cursor-pointer">Spaces</th>
                                <th class="cursor-pointer text-center">Actions</th>
                            </tr>
                            </thead>

                            <tbody>

                            <template v-if="true">
                                <!--NEW RECORD-->
                                <transition name="fade">
                                    <tr v-show="create_new_record_state"
                                        v-bind:class="editing_single_sale ? 'red' : ''">
                                        <td data-info="created_at"></td>
                                        <td data-info="first_name">
                                            <div class="d-flex flex-row">
                                                <input title="first_name" v-model="new_row.first_name" type="text">
                                                <div>
                                                    <a class="btn-floating btn-sm"><i class="fa fa-search"></i></a>
                                                </div>
                                            </div>

                                        </td>
                                        <td data-info="last_name">
                                            <input title="last_name" v-model="new_row.last_name" type="text">
                                        </td>
                                        <td>
                                            <input title="email" class="validate" v-model="new_row.email"
                                                   v-on:change="new_row.email === '' ? new_row.spaces = 1 : ''"
                                                   type="email"
                                            >
                                        </td>
                                        <td data-info="telephone">
                                            <input title="spaces" v-model="new_row.telephone" type="text">
                                        </td>
                                        <td data-info="plate">
                                            <input title="plate"
                                                   v-if="new_row.spaces === 1"
                                                   v-model="new_row.plate"
                                                   :maxlength="plate_length"
                                                   type="text">
                                            <small v-else>You can edit plates afterwards</small>
                                        </td>
                                        <td data-ref="import_single_ticket_chooser_select" v-if="isSingleTicket()">
                                            <material-select
                                                    class="m0"
                                                    :id="single_ticket_chooser.id"
                                                    ref="import_single_ticket_chooser_select"
                                                    data-ref="import_single_ticket_chooser_select"
                                                    @material_select_result="singleMaterialTicketSelect"
                                            />
                                        </td>
                                        <td data-info="spaces">
                                            <input v-model="new_row.spaces" v-bind:disabled="new_row.email === ''"
                                                   min="1"
                                                   value="1"
                                                   type="number" title="spaces"
                                            >
                                        </td>
                                        <td data-info="create_new_record_state" class="">
                                            <div class="d-flex justify-content-around align-items-center cursor-pointer"
                                                 v-on:click="create_new_record_state = false"
                                            >
                                                <i class="material-icons">cancel</i>
                                            </div>
                                        </td>
                                    </tr>
                                </transition>
                            </template>
                            <template v-else>
                                <!--NEW RECORD-->
                                <tr :class="editing_single_sale ? 'd-none' : ''">
                                    <td></td>
                                    <td>
                                        <input v-model="new_row.first_name"
                                               type="text"
                                               title="first_name"
                                        >
                                        <!--<a class="btn-floating btn-sm"><i class="fa fa-search"></i></a>-->
                                    </td>
                                    <td>
                                        <input v-model="new_row.last_name"
                                               type="text"
                                               title="last_name"
                                        >
                                    </td>
                                    <td>
                                        <input class="validate" v-model="new_row.email"
                                               v-on:change="new_row.email === '' ? new_row.spaces = 1 : ''"
                                               type="email"
                                               title="email"
                                        >
                                    </td>
                                    <td>
                                        <input v-model="new_row.telephone"
                                               type="text"
                                               title="telephone"
                                        >
                                    </td>
                                    <td>
                                        <input v-if="new_row.spaces === 1"
                                               v-model="new_row.plate"
                                               type="text"
                                               title="plate"
                                        >
                                        <small v-else>You can edit plates afterwards</small>
                                    </td>
                                    <td>
                                        <input v-model="new_row.spaces"
                                               v-bind:disabled="new_row.email === ''"
                                               min="1" value="1"
                                               title="spaces"
                                               type="number"
                                        >
                                    </td>
                                    <td>
                                        <div class="d-flex justify-content-center align-items-center">
                                            <a v-if="!editing_single_sale"
                                               data-element-type="!editing_single_sale"
                                               class="btn btn-sm btn-primary"
                                               v-on:click="submitNewRow()"
                                            ><i class="material-icons">add</i></a>
                                        </div>

                                    </td>
                                </tr>
                            </template>

                            <!--ALL RESERVATIONS / SALES-->
                            <tr v-if="loading_rows">
                                <td colspan="9" class="text-center">
                                    Loading
                                </td>
                            </tr>

                            <tr v-for="row in sortedCats"
                                v-else-if="rows.length > 0"
                                class="cursor-default">
                                <td class="text-nowrap" v-html="readDate(row.created_at)">
                                </td>
                                <td>
                                    <div v-if="editing_single_sale && row.editing">
                                        <input title="first_name" type="text" v-model="editing_row.first_name"/>
                                    </div>
                                    <div v-else>
                                        <a v-if="canLink(row,'first_name')" :href="createUserLink(row)" target="_blank">
                                            {{row.first_name}}
                                        </a>
                                        <span v-else>{{row.first_name}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="editing_single_sale && row.editing">
                                        <input title="last_name" type="text" v-model="editing_row.last_name"/>
                                    </div>
                                    <div v-else>
                                        <a v-if="canLink(row,'last_name')" :href="createUserLink(row)" target="_blank">
                                            {{row.last_name}}
                                        </a>
                                        <span v-else>{{row.last_name}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="editing_single_sale && row.editing">
                                        <input title="email" type="text" disabled v-model="editing_row.email"/>
                                    </div>
                                    <div v-else>
                                        <a v-if="canLink(row,'email')" :href="mailToUserLink(row)" target="_blank">
                                            {{row.email}}
                                        </a>
                                        <span v-else>{{row.email}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="editing_single_sale && row.editing">
                                        <input title="telephone" type="text" v-model="editing_row.telephone"/>
                                    </div>
                                    <div v-else>
                                        <a v-if="canLink(row,'telephone')" :href="TelUserLink(row)" target="_blank">
                                            {{row.telephone}}
                                        </a>
                                        <span v-else>{{row.telephone}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="editing_single_sale && row.editing">
                                        <input title="plate" type="text" v-model="editing_row.plate"/>
                                    </div>
                                    <div v-else>
                                        <a class="btn btn-sm btn-secondary"
                                           v-on:click="listPlates(row)"
                                        >Plates
                                        </a>
                                    </div>
                                </td>
                                <td v-if="isSingleTicket()"
                                    class="text-nowrap">{{row.ticket}}
                                </td>
                                <td>
                                    <div v-if="editing_single_sale && row.editing">
                                        <input title="spaces"
                                               type="number"
                                               v-bind:disabled="editing_row.email === ''"
                                               min="1"
                                               value="1"
                                               v-model="editing_row.spaces"
                                        />
                                    </div>
                                    <div v-else>
                                        {{row.spaces}}
                                    </div>
                                </td>
                                <td>
                                    <div v-if="!editing_single_sale"
                                         class="btn-group-sm d-block d-md-flex  justify-content-between align-items-center ">
                                        <a class="btn-floating btn-sm btn-info mr-3"
                                           :href="createUserLink(row)"
                                           target="_blank">
                                            <i class="material-icons">face</i>
                                        </a>
                                        <a class="btn-floating btn-sm btn-secondary mr-3" v-on:click="editSale(row)">
                                            <i class="material-icons">edit</i>
                                        </a>
                                        <a class="btn-floating btn-sm btn-danger" v-on:click="confirmRemove(row)">
                                            <i class="material-icons">delete_forever</i>
                                        </a>
                                    </div>

                                    <div v-else-if="row.editing"
                                         class="btn-group-sm d-block d-md-flex  justify-content-between align-items-center">
                                        <a class="btn-floating btn-sm btn-primary mr-2"
                                           v-on:click="submitSaleEdit(row)">
                                            <i class="material-icons">save</i></a>

                                        <a class="btn-floating btn-sm btn-secondary" v-on:click="cancelSaleEdit(row)">
                                            <i class="material-icons">cancel</i></a>
                                    </div>
                                </td>
                            </tr>

                            <tr v-else>
                                <td colspan="8" class="text-center">
                                    List is empty
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <template v-if="true">
                            <div v-if="create_new_record_state">
                                <div v-on:click="submitNewRow()"
                                     data-element-type="create_new_record_state"
                                     class="fixed-action-btn-est btn-floating---submit "
                                     style="bottom: 45px; right: 24px;"
                                >
                                    <div data-icon-button=""
                                         class="animated pulse waves-effect waves-light btn-floating btn-floating--single btn-lg border-0 "
                                    >
                                        <i class="material-icons" aria-hidden="true">save</i>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-on:click="create_new_record_state = true"
                                     class="fixed-action-btn-est btn-floating---submit "
                                     style="bottom: 45px; right: 24px;"
                                >
                                    <div data-icon-button=""
                                         class="animated pulse waves-effect waves-light btn-floating btn-floating--single btn-lg border-0 "
                                    >
                                        <i class="material-icons" aria-hidden="true">add</i>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
        <!--Modals-->
        <!--list of user plates editing-->
        <section>
            <div class="modal fade" id="platesEditingModel" tabindex="-1" role="dialog"
                 aria-labelledby="platesEditingModelLabel" aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="platesEditingModelLabel">Plates for -
                                <b>{{editing_plates.email}}</b>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex justify-content-center align-items-center ">
                                <div>
                                    <p>Create, update or add new plate here</p>
                                    <div data-ref="plates list">
                                        <template v-for="(plate, index, idx) in editing_plates.plates">
                                            <div class="md-form">
                                                <i v-if="plate.original_value"
                                                   class="material-icons prefix d-none d-md-flex"
                                                >create</i>
                                                <i v-else
                                                   class="material-icons prefix d-none d-md-flex"
                                                >add</i>

                                                <div class="watch-transition w-100 p-0 d-flex  justify-content-center align-items-center">
                                                    <input type="text"

                                                           :data_ref="'editing_plates.plates[' + index + ']'"
                                                           title="plate"
                                                           class="plate"
                                                           :ref="'plate_' + index"
                                                           :maxlength="plate_length"
                                                           @keyup="onPlateInput(index,'plate_')"
                                                           @keydown.alt="altKeyPressed(index,true)"
                                                           @keyup.alt="altKeyPressed(index,false)"
                                                           v-model="plate.new_value"

                                                           :disabled="plate.to_delete || plate.alt"
                                                    >
                                                </div>

                                                <div>
                                                    <a class="btn-floating btn-sm btn-danger"
                                                       v-on:click="removePlateFromEditingList(plate, index)"
                                                    >
                                                        <i class="material-icons">delete_forever</i>
                                                    </a>
                                                </div>

                                            </div>
                                            <div v-if="plate.alt"
                                                 v-on:click="altKeyPressed(index,false)"
                                                 class="small p-1 m-1 bg-warning z-depth-1 align-center cursor-pointer">
                                                Do not press the Alt key. Click here to continue editing the plate
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!--                            add new plate button-->
                            <a class="btn-floating btn-primary"
                               v-on:click="editing_plates.plates.push({
									original_value: null, //new entry
									new_value: '',
									to_delete: false,
									created_by: user_id
								})"
                            ><i class="fa fa-plus"></i></a>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" v-on:click="submitPlateChangesOfUser()">Save
                                changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--user_asset error modal-->
        <section>

            <div class="modal-danger modal fade" id="assetDecideModal" tabindex="-1" role="dialog"
                 aria-labelledby="assetDecideModalLabel" aria-hidden="true"
            >
                <div class="modal-dialog modal-full-height modal-top" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="assetDecideModalLabel">{{submit_error.title}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i aria-hidden="true" class="material-icons">close</i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex  justify-content-center align-items-center ">
                                <div>
                                    <h5>Plate entered, belongs to a different user (email)</h5>

                                    <!--<div>-->
                                    <!--<span>{Make me a plate}</span>-->
                                    <!--<span class="font-weight-bold">{{new_row.plate}}</span>-->
                                    <!--</div>-->

                                    <div>
                                        <p>Check the details and confirm that the plate you entered is correct.</p>
                                    </div>
                                    <div v-if="submit_error.extra_info.submitted_user" class="container">
                                        <div class="card-columns">
                                            <div class="card bg-primary text-white">
                                                <div class="card-header">
                                                    <h4>You created</h4>
                                                </div>
                                                <div class="card-body">
                                                    <ul class="list-unstyled">
                                                        <li>
                                                            <span class="text-lowercase font-weight-light">first_name:</span>
                                                            {{submit_error.extra_info.submitted_user.first_name}}
                                                        </li>
                                                        <li>
                                                            <span class="text-lowercase font-weight-light">last_name:</span>
                                                            {{submit_error.extra_info.submitted_user.last_name}}
                                                        </li>
                                                        <li><span class="text-lowercase font-weight-light">email:</span>
                                                            {{submit_error.extra_info.submitted_user.email}}
                                                        </li>
                                                        <li>
                                                            <span class="text-lowercase font-weight-light">telephone:</span>
                                                            {{submit_error.extra_info.submitted_user.telephone}}
                                                        </li>
                                                        <li>
                                                            <span class="text-lowercase font-weight-light">created_at:</span>
                                                            {{submit_error.extra_info.submitted_user.created_at}}
                                                        </li>
                                                    </ul>
                                                    <button class="btn btn-primary"
                                                            v-on:click="resubmitToCreateNewPlate()">Add this
                                                        plate to this user
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card bg-secondary text-white">
                                                <div class="card-header">
                                                    <h4>User Found</h4>
                                                </div>
                                                <div class="card-body">

                                                    <ul class="list-unstyled">
                                                        <li class=""><span class="font-weight-light text-lowercase">first_name:</span>
                                                            {{submit_error.extra_info.other_user.first_name}}
                                                        </li>
                                                        <li class=""><span class="font-weight-light text-lowercase">last_name:</span>
                                                            {{submit_error.extra_info.other_user.last_name}}
                                                        </li>
                                                        <li class=""><span class="font-weight-light text-lowercase">email:</span>
                                                            {{submit_error.extra_info.other_user.email}}
                                                        </li>
                                                        <li class=""><span class="font-weight-light text-lowercase">telephone:</span>
                                                            {{submit_error.extra_info.other_user.telephone}}
                                                        </li>
                                                        <li class=""><span class="font-weight-light text-lowercase">created_at:</span>
                                                            {{submit_error.extra_info.other_user.created_at}}
                                                        </li>
                                                    </ul>
                                                    <button class="btn btn-danger"
                                                            v-on:click="resubmitChangingTheEmail(submit_error.extra_info.other_user.email)"
                                                    >
                                                        Use this user instead
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">

                        </div>
                    </div>
                </div>
            </div>

        </section>

        <!--duplicated asset error modal @todo-->
        <section>

            <div class="modal-danger modal fade" id="assetDecideMultipleModal" tabindex="-1" role="dialog"
                 aria-labelledby="assetDecideMultipleModalLabel" aria-hidden="true"
            >
                <div class="modal-dialog modal-full-height modal-top" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="assetDecideMultipleModalLabel">{{submit_error.title}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex  justify-content-center align-items-center ">
                                <div>
                                    <h5>Check the plate</h5>
                                    <div>
                                        <div class="plate">
                                            {{new_row.plate}}
                                        </div>
                                        <p>Another user has registered this plate. It cannot be assigned to this user
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="submit_error.extra_info.assets" class="container">
                                <table class="table table-sm">
                                    <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Telephone</th>
                                        <th>Email</th>
                                        <th>Plate</th>
                                        <th>Created At</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="asset in submit_error.extra_info.assets">
                                        <td v-if="asset.user_assets_group.user">
                                            {{asset.user_assets_group.user.first_name}}
                                        </td>
                                        <td v-else>{{asset.user_assets_group.user_assets_group_data.first_name}}
                                        </td>

                                        <td v-if="asset.user_assets_group.user">
                                            {{asset.user_assets_group.user.last_name}}
                                        </td>
                                        <td v-else>{{asset.user_assets_group.user_assets_group_data.last_name}}</td>

                                        <td v-if="asset.user_assets_group.user">
                                            {{asset.user_assets_group.user.telephone}}
                                        </td>
                                        <td v-else>{{asset.user_assets_group.user_assets_group_data.telephone}}</td>

                                        <td v-if="asset.user_assets_group.user">
                                            {{asset.user_assets_group.user.email}}
                                        </td>
                                        <td v-else></td>

                                        <td>{{asset.value}}</td>

                                        <td v-if="asset.user_assets_group.user">
                                            {{asset.user_assets_group.user.created_at}}
                                        </td>
                                        <td v-else>{{asset.user_assets_group.created_at}}</td>

                                        <td>
                                            <button data-dismiss="modal" v-if="asset.user_assets_group.user"
                                                    class="btn btn-sm btn-primary"
                                                    v-on:click="resubmitChangingTheEmail(asset.user_assets_group.user.email)"
                                            >
                                                Use
                                            </button>
                                            <button data-dismiss="modal" v-else class="btn btn-sm btn-primary"
                                                    v-on:click="resubmitWithUserAssetsGroup(asset.user_assets_group.id)"
                                            >
                                                Use
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <!--generic error modal-->
        <section>
            <div class="modal-danger modal fade" id="genericErrorModal" tabindex="-1" role="dialog"
                 aria-labelledby="genericErrorModalLabel" aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="genericErrorModalLabel">{{submit_error.title}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex  justify-content-center align-items-center ">
                                <p>{{submit_error.message}}</p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--confirm delete modal-->
        <section>
            <div class="modal-danger modal fade" id="confirmRemoveModal" tabindex="-1" role="dialog"
                 aria-labelledby="confirmRemoveModalLabel" aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="confirmRemoveModalLabel">Confirm</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex  justify-content-center align-items-center ">
                                <p>Are you sure you want delete this reservation?</p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel Action</button>
                            <button type="button" class="btn btn-danger" data-dismiss="modal"
                                    v-on:click="cancelReservation()"
                            >Cancel Reservation
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<style>

</style>

<script>
    import {removeAllWeirdCharacters} from '../../../../../../app/Shared/Resources/Assets/js/helpers/strings.js'
    import {_} from 'underscore';
    import MaterialSelect from '../../forms/select/MaterialSelect.vue';
    import BaseUploader from "../../../../../../app/Shared/Resources/Assets/js/components/base/BaseUploader";
    import {uniqueId} from '../../../helpers/classesAndIds';
    import JsonExcel from "../../export/JsonExcel";
    import BaseButton from "../../../../../../app/Shared/Resources/Assets/js/components/base/buttons/BaseButton";
    import TableEditor from "../../forms/table/TableEditor";
    import BaseSwitch from "../../../../../../app/Shared/Resources/Assets/js/components/base/BaseSwitch";
    import format from 'date-fns/format'
    import lang from "../../../../../../app/Shared/Resources/Assets/js/helpers/lang";
    import BaseLoadingAnimation
        from "../../../../../../app/Shared/Resources/Assets/js/components/base/BaseLoadingAnimation";
    import BoldWords from "../../../../../../app/Shared/Resources/Assets/js/components/BoldWords";
    import PlateFormatMixin from '../../../../../../app/Shared/Resources/Assets/js/components/PlateFormatMixin'

    export default {
        name: 'vip-tickets-admin-list-edit',
        components: {
            TableEditor,
            BaseButton,
            'material-select': MaterialSelect
        },
        mixins: [BaseUploader, PlateFormatMixin],
        props: {

            set_dev: {
                type: Boolean,
                default: false
            },
            ticket_route_template: {
                type: String,
                default: null
            },
            content: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            user_uri: {
                type: String,
                default: null
            },
            create_vip_ticket_uri: {
                type: String,
                default: null
            },
            import_ticket_users_url: {
                type: String,
                default: null
            },
            import_ticket_validate_field_url: {
                type: String,
                default: null
            },
            bookmark_store: {
                type: String,
                default: null
            },
            bookmark_route: {
                type: String,
                default: null
            }
        },
        mounted() {
            this.user_id = this.content.user_id;
            this.events = this.content.events;
            this.season_tickets = this.content.season_tickets;
            this.single_tickets = this.content.single_tickets;

            this.add_new_url = this.content.add_new_url;
            this.update_reservation_url = this.content.update_reservation_url;
            this.cancel_reservation_url = this.content.cancel_reservation_url;
            this.update_plates_url = this.content.update_plates_url;
            this.get_list_url = this.content.get_list_url;
            this.get_available_spaces = this.content.get_available_spaces;

            this.uploaderUrl = this.import_file.uploadUrl = this.import_ticket_users_url;
            this.plate_length = this.max_plate_length;
            this.prepareLists();
        },
        data() {
            return {
                plate_length:null,
                altPressed: false,
                total_imported: 0,
                /**
                 * imported_checklist
                 * @type {Object}
                 * @property {boolean} has_errors
                 * @property {Object} headers
                 * @property {Array} insert_errors
                 * @property {Array} inserted
                 * @property {boolean} no_spaces
                 * @property {Object} uploaded_records
                 * @property {Object} valid
                 */
                imported_checklist: null,
                create_new_record_state: false,
                user_id: 0,
                events: [],
                season_tickets: [],
                single_tickets: [],

                selected_tickets_for_event: [],

                page_selected: 'vip_single_tickets',


                import_file: {
                    uploadUrl: null,
                    fileCount: 0,
                    show_import_dialog: false,
                    uploadFieldName: '',
                    isInitial: true,
                    isSaving: false,
                    csv_type: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                },

                editing_single_sale: false,

                table_list_active: false,
                loading_rows: false,
                loading_spaces_available: false,

                event_chooser: {
                    id: ''
                },

                season_ticket_chooser: {
                    id: ''
                },

                single_ticket_chooser: {
                    id: ''
                },

                current_event_selected: {},
                current_ticket_selected: {},

                add_new_url: '',
                update_reservation_url: '',
                cancel_reservation_url: '',
                update_plates_url: '',
                get_list_url: '',
                get_available_spaces: '',

                editing_plates: {
                    plates: [],
                    original_plates: [],
                    email: ''
                },

                submit_error: {
                    title: '',
                    message: '',
                    extra_info: {}
                },

                new_row: {
                    id: null,
                    first_name: '',
                    last_name: '',
                    email: '',
                    telephone: '',
                    address: '',
                    plate: '',
                    spaces: 1,
                    ticket: null,
                    editing: false
                },
                current_ticket_id: null,
                current_single_ticket_name: null,

                editing_row: {},
                rows: [],
                currentSort: 'created_at',
                currentSortDir: 'desc',
                total_results: 0,
                pageSize: 10,
                currentPage: 1,
                searchString: '',
                view_single_ticket: null,
                view_all_allocations: false,
            };
        },
        watch: {
            'import_file.show_import_dialog'(value) {
                if (value) {
                    if (this.isSingleTicket()) {
                        this.startSingleTicketMaterialSelect();
                    }
                }

            },
            'new_row.plate'(newPlate, OldPlate) {
                this.new_row.plate = this.cleanPlateOnInput(newPlate);
            },
            uploaderIsSuccess(record) {
                console.log('uploaderIsSuccess', record)
            },
            /**
             * @param data
             * @type {Object}
             * @property {boolean} has_errors
             * @property {Object} headers
             * @property {Array} insert_errors
             * @property {Array} inserted
             * @property {boolean} no_spaces
             * @property {Object} uploaded_records
             * @property {Object} valid
             */
            uploadedResponse(data) {
                this.imported_checklist = data;
                this.updateTotalImported();
            },
            uploaderCurrentStatus(status) {
                // console.log('uploaderCurrentStatus', status)
            },
            'new_row.spaces'(new_space, old_space) {
                //@todo check the capacity of the ticket selected
                if (new_space > this.current_ticket_selected.spaces) {
                    this.new_row.spaces = old_space;
                } else if (new_space < 1) {
                    this.new_row.spaces = old_space;
                } else {
                    this.new_row.plate = '';
                }
            }
        },
        computed: {

            getTotalSuccessfulImports() {
                return this.imported_checklist.uploaded_records.count;
            },
            getTotalFailedImports() {
                let invalid = this.imported_checklist.invalid.count;
                let insert_errors = this.imported_checklist.insert_errors.length;

                return insert_errors + invalid;
            },
            getTotalAllocation() {
                return this.selected_tickets_for_event.reduce((a, b) => a + (b['allocated'] || 0), 0);
            },
            getTotalSpaces() {
                return this.selected_tickets_for_event.reduce((a, b) => a + (b['spaces'] || 0), 0);
            },
            getSelectedTicket() {
                if (this.isSingleTicket()) {
                    return this.current_ticket_id;
                } else {
                    return this.current_ticket_selected.id
                }
            },
            hasImportedErrors() {
                if (typeof this.imported_checklist === 'undefined' || this.imported_checklist === null) {
                    return false
                }
                if (this.containsKey(this.imported_checklist, 'has_errors')) {
                    return this.imported_checklist.has_errors;

                }
                return false;
            },
            canAllocate() {
                let self = this,
                    spaces = 0;


                for (let i = 0; i < self.selected_tickets_for_event.length; i++) {
                    let ticket = self.selected_tickets_for_event[i];
                    let space = ticket['spaces'];
                    if (!(typeof space === 'undefined' || space === null)) {
                        spaces = space + spaces;
                    }
                }
                return spaces > 0;
            },
            uploader_status: function () {
                return !!this.uploaderIsSuccess();
            },
            number_of_pages() {
                return Math.ceil(this.total_results / this.pageSize);
            },
            can_use_next() {
                return (Math.ceil(this.total_results / this.pageSize) > this.currentPage);
            },
            /**
             * @link https://www.raymondcamden.com/2018/02/08/building-table-sorting-and-pagination-in-vuejs
             * @returns {any[]}
             */
            sortedCats() {
                let self = this,
                    searchString = self.searchString.trim().toLowerCase(),
                    setRow = self.rows;
                self.setCurrentPage();

                if (searchString) {
                    setRow = setRow.filter(function (item) {
                        if (self.searchMatches(item, searchString)) {
                            return item;
                        }
                    });
                }
                if (self.view_single_ticket !== null) {
                    setRow = setRow.filter(function (item) {
                        if (self.view_single_ticket.name === self.sanitiseTicketName(item.ticket)) {
                            return item;
                        }
                    });
                }
                let results = setRow.sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) {
                        return -1 * modifier;
                    }
                    if (a[this.currentSort] > b[this.currentSort]) {
                        return modifier;
                    }
                    return 0;
                }).filter((row, index) => {
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
                this.total_results = setRow.length;
                return results;
            },
            canImport() {
                let self = this,
                    allow = false;

                /**
                 * prevent importer being used if no url has been set
                 */
                if (this.import_ticket_users_url === null) {
                    return false;
                }

                if (self.isSeasonTicket()) {

                    if (!this.ticketIsSelected()) {
                        return false
                    }
                    allow = (this.uploaderIsInitial() || this.uploaderIsSuccess()) && this.canAllocate;

                } else {
                    if (!_.isEmpty(self.current_event_selected)) {
                        allow = true;
                    }
                }
                return allow;
            }
        },

        methods: {
            altKeyPressed(position, set) {
                this.editing_plates.plates[position].alt = set;
            },
            onPlateInput(position,reference) {
                // console.log('position,reference',position,reference)
                this.watchInput(position,reference,this.editing_plates.plates);
            },

            updateTotalImported() {
                if (typeof this.imported_checklist.uploaded_records !== 'undefined') {
                    this.total_imported = this.imported_checklist.uploaded_records.count + this.total_imported;
                }
            },
            show_allocations(ticket) {
                let self = this;

                if (self.view_all_allocations) {
                    return true
                }
                return self.view_single_ticket !== null && ticket.id === self.view_single_ticket.id;

            },
            searchMatches(item, searchString) {
                let self = this;

                return item.first_name !== null && item.first_name.toLowerCase().indexOf(searchString) !== -1
                    || item.last_name !== null && item.last_name.toLowerCase().indexOf(searchString) !== -1
                    || item.email !== null && item.email.toLowerCase().indexOf(searchString) !== -1
                    || self.indexOfPlate(searchString, item);
            },
            sanitiseTicketName(ticket) {
                return removeAllWeirdCharacters(ticket, true).toLowerCase();
            },
            showOneTicketOnly(ticket) {
                if (this.view_single_ticket !== null && ticket.id === this.view_single_ticket.id) {
                    this.view_single_ticket = null;
                } else {
                    this.view_single_ticket = {
                        id: ticket.id,
                        name: this.sanitiseTicketName(ticket.lang.en_GB.title)
                    };
                }
            },
            exportToCSV() {
                let csvContent = "data:text/csv;charset=utf-8,",
                    arrData = [];

                let rawData = this.imported_checklist.insert_errors;
                rawData = rawData.concat(this.imported_checklist.invalid.data);

                // console.log('rawData',rawData)
                for (let x = 0; x < rawData.length; x++) {
                    let item = rawData[x].record;
                    arrData.push(item)
                }

                csvContent += [
                    Object.keys(
                        arrData[0]).join(','),
                    ...arrData.map(
                        item => Object
                            .values(item)
                            .join(',')
                    )
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");
// console.log('csvContent',csvContent)
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", this.getTicketName() + '.csv');
                link.click();
            },
            createTemplateCSV() {
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += 'first_name,last_name,email,telephone,plate1,plate2,plate3,plate4,plate5,spaces';

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", 'vip-import--template.csv');
                link.click();
            },
            getTicketName() {
                let ticket_title = this.isSingleTicket() ? this.current_single_ticket_name : lang('title', this.current_ticket_selected.lang);
                let date = format(new Date(), 'Do-MMM-YY@HH:mm');
                return ticket_title + '-' + date;
            },
            containsKey(obj, key) {
                return Object.keys(obj).includes(key);
            },
            getTicketRoute(ticket) {
                return this.ticket_route_template.replace(/\|.*\|/, ticket.id);
            },
            switchToSeasonTicket(seasonSelected) {
                if (!seasonSelected) {
                    this.selectPage('vip_single_tickets')
                } else {
                    this.selectPage('vip_season_tickets')
                }
                this.resetAll();
            },
            isSeasonTicket() {
                return this.page_selected === 'vip_season_tickets';
            },
            isSingleTicket() {
                return this.page_selected !== 'vip_season_tickets';
            },

            resetAll() {
                this.current_event_selected = {};
                this.current_ticket_selected = {};
                this.current_ticket_id = null;
                this.current_single_ticket_name = null;
                this.view_single_ticket = null;
                this.resetImporter();
            },
            ticketIsSelected() {
                return Object.keys(this.current_ticket_selected).length > 0
            },
            /**
             * Upon completion of corrected imports
             * */
            invalidRecordsCorrected(response) {
                this.imported_checklist = response;
                this.table_list_active = true;
                this.showImportDialog();
            },
            resetImporter() {
                this.total_imported = 0;
                this.uploaderReset();
                this.loadRows();
                this.import_file.show_import_dialog = false;
            },
            showImportDialog() {
                let self = this;
                self.import_file.show_import_dialog = !self.import_file.show_import_dialog;
            },
            /**
             * on change of adding a file this will trigger the upload event
             * @link https://scotch.io/tutorials/how-to-handle-file-uploads-in-vue-2
             */
            uploadFileChange($event) {
                if (this.isSingleTicket()) {
                    this.uploaderAdditionalParams = {
                        'selected_ticket': this.current_ticket_id
                    };
                } else {
                    this.uploaderAdditionalParams = {
                        'selected_ticket': this.current_ticket_selected.id
                    };
                }

                this.import_file.fileCount = $event.target.files.length;
                this.importFilesChange($event.target.name, $event.target.files);
            },
            canLink(row, property) {
                // console.log('canLink', 'row,property',row,property , (property in row));
                return (
                    property in row
                ) && !_.isEmpty(row[property]);
            },

            mailToUserLink(row) {
                return `mailto:${row.email}`;
            },

            /**
             * @return {string}
             */
            TelUserLink(row) {
                return `tel:${row.telephone}`;
            },

            createUserLink(row) {

                let id = row.user_id;
                let splitString = this.user_uri.split('/'),
                    len = splitString.length - 1;
                // get last elements
                let lastElm = splitString[len];
                if (lastElm === 'id') {
                    splitString[len] = id;
                }
                // console.log('getUserSaleLink', 'splitString.join(/)',splitString.join('/'));
                return splitString.join('/');
            },

            log() {
                // 1. Convert args to a normal array
                let args = Array.prototype.slice.call(arguments);

                // 2. Prepend log prefix log string
                // args.unshift(LOG_PREFIX + " ");

                // 3. Pass along arguments to console.log
                console.log.apply(console, args);
            },

            prepareLists() {
                let self = this;

                //Let's select the first event
                // this.selectEventById(self.events[0].id);

                self.initEventMaterialSelect([]);
                self.initSeasonTicketMaterialSelect([]);
            },

            selectTicketById(id) {
                let self = this;

                for (let i = 0; i < self.season_tickets.length; i++) {
                    if (self.season_tickets[i].id === id) {
                        self.current_ticket_selected = self.season_tickets[i];
                        self.selected_tickets_for_event = [self.current_ticket_selected];
                        self.new_row.ticket = id;
                        self.loadRows();
                        break;
                    }
                }
            },

            selectEventById(id) {
                let self = this;

                for (let i = 0; i < self.events.length; i++) {
                    if (self.events[i].id === id) {
                        self.current_event_selected = self.events[i];

                        self.selected_tickets_for_event = [];

                        self.single_tickets.forEach(function (ticket) {
                            if (ticket.events[0].id === id) {
                                self.selected_tickets_for_event.push(ticket);
                            }
                        });

                        self.loadRows();
                        this.startSingleTicketMaterialSelect();
                        break;
                    }
                }
            },
            startSingleTicketMaterialSelect() {
                //After the rows are init, load all vip single tickets for that event
                this.$nextTick(function () {
                    this.initSingleTicketMaterialSelect([]);
                });
            },
            setCurrentPage(value) {
                if (typeof value === 'undefined') {
                    self.currentPage = 1;
                }
                self.currentPage = 1;
            },
            resetSearchPages() {
                let self = this;
                self.searchString = '';
                self.setCurrentPage();
            },

            loadRows() {
                let self = this,
                    list_of_tickets_ids = [];

                self.resetSearchPages();

                //lets update the spaces first
                self.updateSpacesAvailable();

                /** GET ROWS **/

                self.loading_rows = true;
//                console.log(self.selected_tickets_for_event);
                self.selected_tickets_for_event.forEach(function (ticket) {
                    list_of_tickets_ids.push(ticket.id);
                });

                axios.post(self.get_list_url, {
                    tickets: list_of_tickets_ids,
                    page: 1
                })
                    .then(function (response) {
                        if (response.data.success) {
                            self.rows = [];
                            self.loading_rows = false;

                            let groupBySales = _.toArray(_.groupBy(response.data.sales, 'sale_id')).reverse();

                            groupBySales.forEach(
                                /**
                                 * @param {Object} sale[].user_assets_group.user_assets_group_data
                                 * @param {Object} sale[].user_assets_group
                                 * @param {Array} sale[]
                                 */
                                function (sale) {
                                    let spaces = sale.length,
                                        list_of_plates = [],
                                        ticket_info = self.grabTicketDetailsFromId(sale[0].ticket_id);
                                    //console.log('axios', 'sale',sale);
                                    if (sale[0].user_assets_group === null) {
                                        console.error('sale is null', sale)
                                    }
                                    sale[0].user_assets_group.user_assets.forEach(function (asset) {
                                        if (asset.type === 'plate') {
                                            list_of_plates.push(asset);
                                        }
                                    });

                                    // check if the user not defined for the asset?
                                    if (sale[0].user_assets_group.user != null) {
                                        //We must have an user

                                        self.rows.push({
                                            id: sale[0].sale.id,
                                            user_id: sale[0].user_assets_group.user.id,
                                            first_name: sale[0].user_assets_group.user.first_name,
                                            last_name: sale[0].user_assets_group.user.last_name,
                                            email: sale[0].user_assets_group.user.email,
                                            telephone: sale[0].user_assets_group.user.telephone,
                                            ticket: ticket_info,
                                            address: '',
                                            plate: list_of_plates,
                                            spaces: spaces,
                                            editing: false,
                                            created_at: sale[0].created_at
                                        });
                                    } else {

                                        /**
                                         * @TODO there is a reason for this not being null. check the logic for this procedure
                                         */
                                        if (sale[0].user_assets_group.hasOwnProperty('user_assets_group_data') && sale[0].user_assets_group.user_assets_group_data != null) {

                                            self.rows.push({
                                                id: sale[0].sale.id,
                                                user_id: sale[0].user_assets_group.user_assets_group_data.id,
                                                first_name: sale[0].user_assets_group.user_assets_group_data.first_name,
                                                last_name: sale[0].user_assets_group.user_assets_group_data.last_name,
                                                email: '',
                                                telephone: sale[0].user_assets_group.user_assets_group_data.telephone,
                                                ticket: ticket_info,
                                                address: '',
                                                plate: list_of_plates[0].value,
                                                spaces: spaces,
                                                editing: false,
                                                created_at: sale[0].created_at
                                            });

                                        } else {
                                            console.error('sale[0] user_assets_group does not contain user_assets_group_data', sale[0]);
                                        }

                                    }
                                });
                        }
                    });
            },

            grabTicketDetailsFromId(id) {
                for (let i = 0; i < this.selected_tickets_for_event.length; i++) {
                    if (this.selected_tickets_for_event[i].id === id) {
                        //@todo change the lang stuff
                        return this.selected_tickets_for_event[i].ticket_data.lang.en_GB.title;
                    }
                }
            },

            updateSpacesAvailable() {
                let
                    self = this,
                    tickets = [];

                self.loading_spaces_available = true;

                self.selected_tickets_for_event.forEach(function (ticket) {
                    tickets.push(ticket.id);
                });

                axios.post(self.get_available_spaces, {
                    tickets: tickets,
                    event_id: self.current_event_selected.id
                })
                    .then(function (response) {
                        if (response.data.success) {
                            for (let i = 0; i < tickets.length; i++) {
                                //self.selected_tickets_for_event[i].$set('spaces',response.data.tickets[i].spaces);
                                //  self.selected_tickets_for_event[i].spaces = response.data.tickets[i].spaces;
                                self.setTicketSpaces(self.selected_tickets_for_event, i, response.data.tickets[i].spaces)
                            }

                            self.loading_spaces_available = false;
//                            console.log(self.selected_tickets_for_event);
                        }
                    });
            },
            setTicketSpaces(ticket, index, value) {
                this.$set(ticket[index], 'spaces', value);
            },

            initNewRowData() {
                let
                    self = this;

                self.new_row.first_name = '';
                self.new_row.last_name = '';
                self.new_row.email = '';
                self.new_row.telephone = '';
                self.new_row.address = '';
                self.new_row.plate = '';
                self.new_row.spaces = 1;
                self.new_row.editing = false;
            },

            handleDataAfterSubmit(response) {
                let
                    self = this;

                if (response.data.success) {
                    //everything was ok :D
                    let
                        list_of_plates = [],
                        ticket_info = self.grabTicketDetailsFromId(self.new_row.ticket);

//                    console.log('handleDataAfterSubmit', 'self.new_row.ticket', self.new_row.ticket, 'ticket_info',
//                        ticket_info);
                    response.data.assets.forEach(function (asset) {
                        if (asset.type === 'plate') {
                            list_of_plates.push(asset);
                        }
                    });
                    self.new_row.id = response.data.reservation.id;
                    self.new_row.ticket = ticket_info;
                    self.new_row.editing = false;

                    if (response.data.user != null) {
                        self.new_row.created_at = response.data.user.created_at;
                        self.new_row.first_name = response.data.user.first_name;
                        self.new_row.last_name = response.data.user.last_name;
                        self.new_row.email = response.data.user.email;
                        self.new_row.telephone = response.data.user.telephone;
                        // self.new_row.spaces should be the same
                        self.new_row.plate = list_of_plates;
                    } else {

                        self.new_row.created_at = response.data.created_at;
                        self.new_row.first_name = response.data.first_name;
                        self.new_row.last_name = response.data.last_name;
                        self.new_row.email = '';
                        self.new_row.telephone = response.data.telephone;
                        // self.new_row.spaces should be the same
                        self.new_row.plate = list_of_plates[0].value;
                    }

                    self.rows.unshift($.extend({}, true, self.new_row));

                    self.initNewRowData();

                    this.updateSpacesAvailable();
                    this.initSingleTicketMaterialSelect([]);

                    toastr.success('New reservation was created');
                } else {
                    //We have a problem, let's handle it (usually confirmation stuff)
                    let modalModel = $('#genericErrorModal');

                    switch (response.data.error) {
                        //Generic errors
                        case 'invalid_ticket':
                            self.submit_error.title = 'Invalid Ticket';
                            self.submit_error.message = 'Ticket selected is an invalid ticket';
                            modalModel.modal('toggle');
                            break;
                        case 'spaces_available':
                            if (response.data.max_amount <= 0) {
                                self.submit_error.title = 'No spaces available';
                                self.submit_error.message =
                                    'There are no spaces available for this ticket.';
                            } else {
                                self.submit_error.title = 'Invalid amount of spaces';
                                self.submit_error.message =
                                    'Ticket selected has only ' + response.data.max_amount + ' spaces available.';
                            }
                            modalModel.modal('toggle');
                            break;
                        case 'invalid_spaces':
                            self.submit_error.title = 'Invalid Spaces';
                            self.submit_error.message = 'Invalid amount of spaces to reserve';
                            modalModel.modal('toggle');
                            break;
                        case 'plate_missing':
                            self.submit_error.title = 'Plate Missing';
                            self.submit_error.message = 'You need to provide a plate or a valid email address';
                            modalModel.modal('toggle');
                            break;
                        case 'no_valid_user':
                            //More than one space was assign but there's no user

                            self.submit_error.title = 'Missing User';
                            self.submit_error.message =
                                'You need to provide a valid email address to reserve more than one space';
                            modalModel.modal('toggle');
                            break;

                        //Confirmation stuff
                        case 'user_asset':
                            //plate belongs to another user
                            self.submit_error.title = 'User Assets Collision';
                            self.submit_error.extra_info = {
                                submitted_user: response.data.user_provided,
                                other_user: response.data.user_collided
                            };
                            console.error('handleDataAfterSubmit', 'self.submit_error', self.submit_error);
                            $('#assetDecideModal').modal('toggle');
                            break;

                        case 'duplicated_asset':
                            //This means that more than one plate exists (same plate)
                            self.submit_error.title = 'Choose User';
                            self.submit_error.extra_info = {
                                assets: response.data.assets
                            };

                            $('#assetDecideMultipleModal').modal('toggle');
                            break;

                        default:
                            toastr.error('Unknown error: ' + response.data.error);
                            break;
                    }

                }
            },

            resubmitChangingTheEmail(email) {
                let self = this;

                //Replace the email
                self.new_row.email = email;

                axios.post(self.add_new_url, {
                    ticket: self.new_row.ticket,
                    email: self.new_row.email,
                    spaces: self.new_row.spaces,
                    plate: self.new_row.plate
                })
                    .then(function (response) {
                        self.handleDataAfterSubmit(response);
                    });
            },

            resubmitWithUserAssetsGroup(user_assets_group_id) {
                let self = this;

                axios.post(self.add_new_url, {
                    ticket: self.new_row.ticket,
                    spaces: self.new_row.spaces,
                    plate: self.new_row.plate,
                    user_assets_group_id: user_assets_group_id,
                    first_name: self.new_row.first_name,
                    last_name: self.new_row.last_name,
                    telephone: self.new_row.telephone,
                    address: self.new_row.address

                })
                    .then(function (response) {
                        self.handleDataAfterSubmit(response);
                    });
            },

            resubmitToCreateNewPlate() {
                let self = this;

                axios.post(self.add_new_url, {
                    ticket: self.new_row.ticket,
                    email: self.new_row.email,
                    spaces: self.new_row.spaces,
                    address: self.new_row.address,
                    plate: self.new_row.plate,
                    first_name: self.new_row.first_name,
                    last_name: self.new_row.last_name,
                    telephone: self.new_row.telephone,

                    create_new_asset: true
                })
                    .then(function (response) {
                        self.handleDataAfterSubmit(response);
                    });
            },

            editSale(row) {
                console.log('editSale', 'row', row);
                row.editing = true;
                this.editing_row = $.extend({}, true, row);
                this.editing_single_sale = true;
            },

            cancelSaleEdit(row) {
                row.editing = false;
                this.editing_row = {};
                this.editing_single_sale = false;
            },

            submitSaleEdit(row) {
                let self = this;

                axios.post(self.update_reservation_url, {
                    sale_id: self.editing_row.id,
                    first_name: self.editing_row.first_name,
                    last_name: self.editing_row.last_name,
                    telephone: self.editing_row.telephone,
                    spaces: self.editing_row.spaces,
                    plate: self.editing_row.plate
                })
                    .then(function (response) {
                        if (response.data.success) {
                            //we need to update rows again :/
                            row.editing = false;
                            self.editing_row = {};
                            self.editing_single_sale = false;

                            self.loadRows();
                        }
                    });
            },

            confirmRemove(row) {
                this.editing_row = $.extend({}, true, row);
                $('#confirmRemoveModal').modal();
            },

            cancelReservation() {
                let self = this;

                axios.post(self.cancel_reservation_url, {
                    sale_id: self.editing_row.id,
                    other_details: self.editing_row
                })
                    .then(function (response) {
                        if (response.data.success) {
                            self.rows = _.without(self.rows, _.findWhere(self.rows, {
                                id: self.editing_row.id
                            }));

                            self.editing_row = {};

                            self.updateSpacesAvailable();
                        } else {
                            toastr.error(response.data.error_msg);
                        }
                    });
            },

            submitNewRow() {
                let self = this;

                if (self.new_row.ticket === null) {
                    alert('Please select a ticket');
                    return;
                }

                // if (self.new_row.spaces === 1 && self.new_row.plate === '' && self.new_row.email === '') {
                //     alert('Please fill a plate or an email address');
                //     return;
                // }
                // console.log('submitNewRow', 'sumitting', self.new_row);
                axios.post(self.add_new_url, {
                    ticket: self.current_ticket_id,
                    email: self.new_row.email,
                    spaces: self.new_row.spaces,
                    address: self.new_row.address,
                    plate: self.new_row.plate,
                    first_name: self.new_row.first_name,
                    last_name: self.new_row.last_name,
                    telephone: self.new_row.telephone
                })
                    .then(function (response) {
                        self.handleDataAfterSubmit(response);
                        self.create_new_record_state = false;
                    });
            },

            /* Change plates */

            submitPlateChangesOfUser() {
                let self = this;

                axios.post(self.update_plates_url, {
                    email: self.editing_plates.email,
                    plates: self.editing_plates.plates
                })
                    .then(function (response) {
                        if (response.data.success) {
                            $('#platesEditingModel').modal('toggle');
                            self.loadRows();
                        }
                    });
            },

            removePlateFromEditingList(plate, index) {

                // if (plate.created_by != this.user_id) {
                //     toastr.error('You cannot change plates that have been set by the owner');
                //     return;
                // }

                if (plate.original_value == null) {
                    this.$delete(this.editing_plates.plates, index);
                    // toastr.error('original_value is null');
                } else {
                    if (plate.new_value === plate.original_value) {
                        // toastr.error('new value is original value');
                        plate.to_delete = true;
                    } else {
                        plate.new_value = plate.original_value;
                        // toastr.error('reseting value');
                    }
                }
            },

            listPlates(row) {
                let self = this;

                if (self.editing_single_sale) {
                    return;
                }

                self.editing_plates.email = row.email;
                self.editing_plates.plates = [];

                row.plate.forEach(function (plate) {
                    self.editing_plates.plates.push({
                        original_value: plate.value,
                        new_value: plate.value,
                        created_by: plate.created_by,
                        to_delete: false,
                        alt: false,
                        focused: false
                    });
                });

                $('#platesEditingModel').modal('toggle');
            },

            /* Navigation Stuff */

            selectPage(page) {

                //do some validation stuff, reload stuff if needed
                this.page_selected = page;

                if (page === 'vip_single_tickets') {
                    this.initEventMaterialSelect([]);
                } else {
                    this.initSeasonTicketMaterialSelect([]);
                }

                this.table_list_active = false;
            },

            /* Material Select Stuff */

            eventMaterialSelect(items) {
                if (items.length > 0) {
                    this.selectEventById(items[0].optionValue);
                    this.table_list_active = true;
                } else {
                    this.table_list_active = false;
                    this.resetAll();
                    //@todo refresh rows
                    console.warn('eventMaterialSelect', '@todo refresh rows');
                }
            },

            singleMaterialTicketSelect(items) {
                if (items.length > 0) {
                    this.current_ticket_id = items[0].optionValue;
                    this.new_row.ticket = this.current_ticket_id;
                    this.current_single_ticket_name = items[0].title;
                } else {
                    this.new_row.ticket =
                        this.current_ticket_id =
                            this.current_single_ticket_name = null;
                }
            },

            ticketMaterialSelect(items) {
                if (items.length > 0) {
                    this.current_ticket_id = items[0].optionValue;
                    this.current_single_ticket_name = items[0].title;
                    this.selectTicketById(this.current_ticket_id);
                    this.table_list_active = true;
                } else {
                    this.current_ticket_selected = {};
                    this.table_list_active = false;
                    //@todo refresh rows
                }
            },

            initSingleTicketMaterialSelect: function (groups) {
                let
                    self = this;

                self.single_ticket_chooser = {
                    params: {
                        multiple: false,
                        //                        grouped: [],1
                        grouped: groups,
                        group_by: '',
                        top_option: {
                            title: 'Select a ticket'
                        },
                        selected_input_name: 'single_ticket_select',
                        label: 'Select ticket',
                        placeholder: 'Select a ticket',
                        id: uniqueId('ticket_chooser'),
                        link: {
                            add: false
                        }
                    },
                    select_items: self.selected_tickets_for_event
                };

                if (typeof self.$refs.single_ticket_chooser_select !== 'undefined' &&
                    self.$refs.single_ticket_chooser_select !== null) {
                    self.$refs.single_ticket_chooser_select
                        .updateMenu(self.single_ticket_chooser);

                }
                if (typeof self.$refs.import_single_ticket_chooser_select !== 'undefined' &&
                    self.$refs.import_single_ticket_chooser_select !== null) {
                    self.$refs.import_single_ticket_chooser_select.updateMenu(self.single_ticket_chooser);
                }
            },

            initSeasonTicketMaterialSelect: function (groups) {
                let self = this;

                self.season_ticket_chooser = {
                    params: {
                        multiple: false,
                        //                        grouped: [],
                        grouped: groups,
                        group_by: '',
                        top_option: {
                            title: 'Add existing vip season ticket'
                        },
                        selected_input_name: 'ticket_select',
                        label: null,
                        placeholder: 'Choose a season ticket',
                        id: uniqueId('ticket_chooser'),
                        link: {
                            add: false
                        }
                    },
                    select_items: self.season_tickets
                };

                self.$refs.ticket_chooser_select.updateMenu(self.season_ticket_chooser);
            },

            initEventMaterialSelect: function (groups) {
                let self = this;

                self.event_chooser = {
                    params: {
                        multiple: false,
                        //                        grouped: [],
                        grouped: groups,
                        group_by: '',
                        top_option: {
                            title: 'Add existing event'
                        },
                        selected_input_name: 'event_select',
                        label: null,
                        placeholder: 'Choose an event for single ticket',
                        id: uniqueId('event_chooser'),
                        link: {
                            add: false
                        }
                    },
                    select_items: self.events
                };

                self.$refs.event_chooser_select.updateMenu(self.event_chooser);
            },
            readDate(date) {
                let dateMonthYear = format(date, 'Do MMM YY'),
                    time = format(date, '@ HH:mm');
                return `
                <span class="d-block d-md-inline">${dateMonthYear}</span>
                <span class="d-block d-md-inline">${time}</span>
                `;
            },
            sort(field) {
                // if field == currentSort, reverse
                if (field === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
                }
                this.currentSort = field;
            },
            nextPage: function () {
                if ((this.currentPage * this.pageSize) < this.rows.length) this.currentPage++;
            },
            prevPage: function () {
                if (this.currentPage > 1) this.currentPage--;
            },
            indexOfPlate(find, item) {
                let plates = item.plate;
                for (let i = 0; i < plates.length; i++) {
                    let plate = plates[i].value;
                    if (plate.toLowerCase().indexOf(find) !== -1) {
                        return true;
                    }
                }
                return false;
            }
        }
    };
</script>
<style scoped>
    .yup {
        background-color: green;
    }

    .nope {
        background-color: red;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/VipTicketsAdminListEdit.vue?5c39df06